<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-button type="primary" size="small" @click="openClose">
          <i
            :class="
              showAdvanceSearchVisible
                ? 'fa fa-angle-double-up'
                : 'fa fa-angle-double-down'
            "
            aria-hidden="true"
          ></i>
          开关搜索条件区域</el-button
        >
      </div>
      <!-- 右边工具 -->
      <div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="showAddView"
          size="small"
          v-if="qx"
          >添加工作日志</el-button
        >
      </div>
    </div>

    <!-- 动画效果 -->
    <transition name="slide-fade">
      <!-- 高级搜索框  -->
      <div
        v-show="showAdvanceSearchVisible"
        style="
          border: 1px solid #409eff;
          border-radius: 5px;
          box-sizing: border-box;
          padding: 5px;
          margin: 10px 0px;
        "
      >
        <el-row>
          <el-col :span="4">
            <el-input
              style="width: 150px; margin-right: 10px"
              prefix-icon="el-icon-edit"
              v-model="searchValue.subject"
              size="mini"
              placeholder="请输入主题"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              style="width: 150px; margin-right: 10px"
              prefix-icon="el-icon-edit"
              v-model="searchValue.custName"
              size="mini"
              placeholder="请输入客户名称"
              clearable
            >
            </el-input>
          </el-col>

          <el-col :span="4">
            <el-input
              style="width: 150px; margin-right: 10px"
              prefix-icon="el-icon-edit"
              v-model="searchValue.chanceName"
              size="mini"
              placeholder="请输入商机名称"
              clearable
            >
            </el-input>
          </el-col>

          <el-col :span="4">
            <el-date-picker
              size="mini"
              v-model="searchValue.rq"
              style="width: 150px"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择工作日期"
            >
            </el-date-picker>
          </el-col>

          <el-col :span="4">
            <el-select
              v-model="searchValue.userId"
              size="mini"
              style="width: 150px"
              placeholder="人员"
              clearable
            >
              <el-option
                v-for="item in userIds"
                :key="item.id"
                :label="item.uname"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="4">
            <el-button
              @click="onSearch"
              size="mini"
              icon="el-icon-search"
              type="primary"
              >搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
    </transition>

    <!-- 表格 -->
    <div style="margin-top: 20px">
      <el-table
        :data="queryData"
        stripe
        border
        :row-style="{ height: '58px' }"
        height="calc(100vh - 280px)"
        :cell-style="{ padding: '5px 0' }"
        fit
        size="small"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <!-- 多选框 -->
        <!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
        <el-table-column prop="subject" label="主题" align="center" width="150">
        </el-table-column>
        <el-table-column prop="rq" label="日志日期" align="center" width="90">
        </el-table-column>
        <el-table-column prop="sjName" label="时间段" align="center" width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line">
        </el-table-column>
        <el-table-column
          prop="thingTypeName"
          label="事务类型"
          align="center"
          width="90"
        >
        </el-table-column>
        <el-table-column
          prop="workTypeName"
          label="工作种类"
          align="center"
          width="90"
        >
        </el-table-column>
        <el-table-column prop="userName" label="员工" align="center" width="90">
        </el-table-column>
        <el-table-column
          prop="custName"
          label="客户名称"
          align="center"
          width="260"
        >
        </el-table-column>
        <el-table-column
          prop="custLinkMan"
          label="联系人"
          align="center"
          width="90"
        >
        </el-table-column>
        <el-table-column prop="result" label="效果" align="center" width="150">
        </el-table-column>
        <el-table-column prop="chanceName" label="商机名称" align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建日期"
          align="center"
          width="150"
        
        :formatter="dateTimeTwoLine"
        class-name="cell-two-line"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="160"
          v-if="qx"
        >
          <template slot-scope="scope">
            <!-- <el-button type="primary" size="mini" style="padding: 2px">编辑</el-button> -->
            <el-button
              type="primary"
              size="mini"
              @click="showEditView(scope.row)"
              :disabled="kaiguan(scope.row.createTime)"
              >编辑</el-button
            >
            <!-- <el-button type="danger" size="mini" style="padding: 2px">删除</el-button> -->
            <el-button
              type="danger"
              @click="deleteRecord(scope.row)"
              size="mini"
              :disabled="kaiguan(scope.row.createTime)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[10, 20, 50, 100, 1000]"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page">
        </el-pagination>
      </div>
    </div>

    <!-- 弹出框  dialogVisible:是否弹出 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="80%"
      top="0px"
            :close-on-click-modal="false"
      :close-on-press-escape="false"

    >
      <div>
        <!-- 增加一层 el-form表单，可以数据校验 -->
        <el-form ref="inputForm" :model="inputObj" :rules="rules">
          <el-row>
            <el-col :span="8">
              <el-form-item label="工作日期" prop="rq">
                <el-date-picker
                  size="mini"
                  v-model="inputObj.rq"
                  style="width: 150px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="时间段" prop="sj" style="margin-left: 0px">
                <el-select
                  v-model="inputObj.sj"
                  placeholder="请选择"
                  size="mini"
                  style="width: 150px"
                  clearable
                >
                  <el-option
                    v-for="item in sjs"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item
                label="事务类型"
                prop="thingType"
                style="margin-left: 12px"
              >
                <el-select
                  v-model="inputObj.thingType"
                  placeholder="请选择"
                  size="mini"
                  style="width: 150px"
                  clearable
                  @change="thingTypeChange"
                  @clear="clearDo"
                >
                  <el-option
                    v-for="item in thingTypes"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-show="isShow1">
            <el-col :span="8">
              <el-form-item label="工作种类" prop="workType">
                <el-select
                  v-model="inputObj.workType"
                  placeholder="请选择"
                  size="mini"
                  style="width: 150px"
                >
                  <el-option
                    v-for="item in workTypes1"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="16">
              <el-form-item
                label="    主题"
                prop="subject"
                style="margin-left: 14px"
              >
                <span> &nbsp;&nbsp;</span>
                <el-input
                  type="text"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 78%"
                  v-model="inputObj.subject"
                  placeholder="请输入主题"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-show="isShow2">
            <el-col :span="12">
              <el-form-item label="工作种类" prop="workType">
                <el-select
                  v-model="inputObj.workType"
                  placeholder="请选择"
                  size="mini"
                  style="width: 300px"
                >
                  <el-option
                    v-for="item in workTypes"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                label="工作场地"
                prop="workField"
                style="margin-left: 0px"
              >
                <el-select
                  v-model="inputObj.workField"
                  placeholder="请选择"
                  size="mini"
                  style="width: 300px"
                  clearable
                >
                  <el-option
                    v-for="item in workFields"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-show="isShow2">
            <el-col :span="8">
              <el-form-item
                label="客户"
                prop="custId"
                style="margin-left: 28px"
              >
                <el-select
                  v-model="inputObj.custId"
                  placeholder="请选择"
                  size="mini"
                  filterable
                  @change="custChange"
                  style="width: 150px"
                  clearable
                  @clear="clearCust"
                >
                  <el-option
                    v-for="item in custIds"
                    :key="item.id"
                    :label="item.custName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item
                label="联系人"
                prop="linkId"
                style="margin-left: 14px"
              >
                <el-select
                  v-model="inputObj.linkId"
                  placeholder="请选择"
                  size="mini"
                  style="width: 150px"
                  clearable
                >
                  <el-option
                    v-for="item in linkIds"
                    :key="item.id"
                    :label="item.linkName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item
                label="商机"
                prop="chanceId"
                style="margin-left: 14px"
              >
                <el-select
                  v-model="inputObj.chanceId"
                  placeholder="请选择"
                  size="mini"
                  style="width: 150px"
                  clearable
                >
                  <el-option
                    v-for="item in chanceIds"
                    :key="item.id"
                    :label="item.chanceName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-show="isShow2">
            <el-col :span="24">
              <el-form-item
                label="    效果"
                prop="result"
                style="margin-left: 28px"
              >
                <span> &nbsp;&nbsp;</span>
                <el-input
                  type="textarea"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 80%"
                  v-model="inputObj.result"
                  placeholder="请输入效果"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button @click="doChance">取 消</el-button>
        <el-button type="primary" @click="doAddRecord">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { kz1 } from "../../utils/MyFunction";

export default {
  name: "WlogList",
  data() {
    return {
      qx: true, // 总经理、销售总监编辑的权限
      title: "",
      isShow1: false,
      isShow2: false,
      queryData: [], // 存放查询结果
      showAdvanceSearchVisible: false,
      searchValue: {
        subject: "",
        custName: "",
        chanceName: "",
        rq: null,
        userId: null,
      },
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      dialogVisible: false,
      // 新增收入对象
      inputObj: {
        chanceId: null,
        rq: "",
        sj: "",
        thingType: null,
        workType: null,
        subject: "",
        workField: "",
        custId: null,
        linkId: null,
        chanceId: null,
        result: "",
      },
      userIds: [], //员工id-员工名称下拉框
      sjs: [], // 时间段下拉框
      thingTypes: [], // 事务类型下拉框
      workTypes: [], // 工作类型下拉框
      workFields: [], // 工作场地下拉框
      custIds: [], // 下拉框显示客户名称
      linkIds: [], // 下拉框客户联系人
      chanceIds: [], //商机下拉框
      workTypes1: [
        {
          code: "1",
          name: "培训、会议",
        },
      ], // 工作类型下拉框
      rules: {
        rq: [
          {
            required: true,
            message: "请选择工作日期",
            trigger: "blur",
          },
        ],
        sj: [
          {
            required: true,
            message: "请选择时间段",
            trigger: "blur",
          },
        ],
        thingType: [
          {
            required: true,
            message: "请选择事务类型",
            trigger: "blur",
          },
        ],
        workType: [
          {
            required: true,
            message: "请选择工作类型",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.quanxian();
    this.initData();
    this.initDim();
  },
  methods: {
    quanxian() {
      if (!window.sessionStorage.getItem("userRoleId")) {
        //权限为空
        // 暂时不做处理，本来应该直接退出
      } else {
        if (window.sessionStorage.getItem("userRoleId") == 8) {
          this.qx = false;
        }
        if (window.sessionStorage.getItem("userRoleId") == 17) {
          this.qx = false;
        }
      }
    },
    kaiguan(sj) {
      var sf = kz1(sj);
      return sf;
    },
    clearCust() {
      // 清空客户
      this.inputObj.custId = null;
      this.inputObj.linkId = null;
    },
    custChange() {
      // 新增商机时，当所属客户下拉框改变时，响应的客户联系人 需要重新提供选择
      // this.inputObj.linkId = ''
      this.getRequest(
        "/cust/link_man_list?custId=" + this.inputObj.custId
      ).then((resp) => {
        if (resp) {
          this.linkIds = resp.data;
          this.saveDictCache("linkIds", resp.data);
        }
      });
      this.getRequest("/sale/list?custId=" + this.inputObj.custId).then(
        (resp) => {
          if (resp) {
            this.chanceIds = resp.data;
            this.saveDictCache("chanceIds", resp.data);
          }
        }
      );
    },
    clearDo() {
      this.isShow1 = false;
      this.isShow2 = false;
    },
    thingTypeChange() {
      if (this.inputObj.thingType == 1) {
        this.isShow1 = true;
        this.isShow2 = false;
      }
      if (this.inputObj.thingType == 2) {
        this.isShow1 = false;
        this.isShow2 = true;
      }
    },
    openClose() {
      this.showAdvanceSearchVisible = !this.showAdvanceSearchVisible;
      this.searchValue.subject = "";
      this.searchValue.custName = "";
      this.searchValue.chanceName = "";
      this.searchValue.rq = null;
      this.searchValue.userId = null;
    },
    doChance() {
      this.dialogVisible = false;
      this.initData();
      this.isShow1 = false;
      this.isShow2 = false;
    },
    showEditView(data) {
      this.getRequest("/cust/link_man_list?custId=" + data.custId).then(
        (resp) => {
          if (resp) {
            this.linkIds = resp.data;
          }
        }
      );
      this.getRequest("/sale/list?custId=" + data.custId).then((resp) => {
        if (resp) {
          this.chanceIds = resp.data;
          // alert(JSON.stringify(resp.data))
        }
      });
      this.title = "编辑工作日志";
      this.dialogVisible = true;
      this.inputObj = data;
      this.inputObj.sj = data.sj + "";
      this.inputObj.thingType = data.thingType + "";
      if (data.thingType == 1) {
        this.isShow1 = true;
        this.isShow2 = false;
        this.inputObj.workField = null;
      }
      if (data.thingType == 2) {
        this.isShow2 = true;
        this.isShow1 = false;
        this.inputObj.workField = data.workField + "";
      }
      this.inputObj.workType = data.workType + "";

      // this.inputObj.chanceId = data.chanceId + ''
    },
    deleteRecord(data) {
      this.$confirm("此操作将永久删除该条日志明细, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.postRequest2("/work_log/delete?id=" + data.id).then((resp) => {
            if (resp) {
              this.initData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    doAddRecord() {
      // 【 添加功能 + 编辑修改 】
      if (this.inputObj.id) {
        // 编辑修改
        // alert(JSON.stringify(this.inputObj))
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/work_log/update", this.inputObj).then(
              (resp) => {
                if (resp) {
                  this.dialogVisible = false;
                  this.initData();
                }
              }
            );
          }
        });
      } else {
        // 添加
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/work_log/add", this.inputObj).then((resp) => {
              if (resp) {
                this.dialogVisible = false;
                this.initData();
                this.isShow1 = false;
                this.isShow2 = false;
              }
            });
          }
        });
      }
      // this.initData()
      // this.dialogVisible = false
    },
    initDim() {
      // 员工
      if (!window.sessionStorage.getItem("userIds")) {
        this.getRequest("/user/queryAllSales").then((resp) => {
          if (resp) {
            this.userIds = resp;
            this.saveDictCache("userIds", resp);
          }
        });
      } else {
        this.userIds = this.dictCache("userIds");
      }
      // 时间段
      if (!window.sessionStorage.getItem("sjs")) {
        this.postRequest("/dim/dim_table_char/sj").then((resp) => {
          if (resp) {
            this.sjs = resp.result;
            this.saveDictCache("sjs", resp.result);
          }
        });
      } else {
        this.sjs = this.dictCache("sjs");
      }
      // 事务类型
      if (!window.sessionStorage.getItem("thingTypes")) {
        this.postRequest("/dim/dim_table_char/thing_type").then((resp) => {
          if (resp) {
            this.thingTypes = resp.result;
            this.saveDictCache("thingTypes", resp.result);
          }
        });
      } else {
        this.thingTypes = this.dictCache("thingTypes");
      }
      // 工作类型
      if (!window.sessionStorage.getItem("workTypes")) {
        this.postRequest("/dim/dim_table_char/work_type").then((resp) => {
          if (resp) {
            this.workTypes = resp.result;
            this.saveDictCache("workTypes", resp.result);
          }
        });
      } else {
        this.workTypes = this.dictCache("workTypes");
      }
      // 工作场地
      if (!window.sessionStorage.getItem("workFields")) {
        this.postRequest("/dim/dim_table_char/work_field").then((resp) => {
          if (resp) {
            this.workFields = resp.result;
            this.saveDictCache("workFields", resp.result);
          }
        });
      } else {
        this.workFields = this.dictCache("workFields");
      }
      // 客户名称列表
      if (!window.sessionStorage.getItem("custIds")) {
        this.getRequest("/cust/list?page=1&limit=200").then((resp) => {
          if (resp) {
            this.custIds = resp.data;
            this.saveDictCache("custIds", resp.data);
          }
        });
      } else {
        this.custIds = this.dictCache("custIds");
      }
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initData();
    },
    sizeChange(limit) {
      this.page = 1; // 改每页条数：回到第 1 页
      this.limit = limit;
      this.initData();
    },
    showAddView() {
      this.title = "添加工作日志";
      this.dialogVisible = true;
      this.inputObj = {
        id: null,
        rq: "",
        income: null,
        // createTime: null,
        // updateTime: null
      };
    },
    // 搜索入口：先回到第 1 页再查
    onSearch() {
      this.page = 1;
      this.initData();
    },

    initData() {
      this.loading = true;
      let url = "/work_log/list/?page=" + this.page + "&limit=" + this.limit;
      if (this.searchValue.subject) {
        url += "&subject=" + this.searchValue.subject;
      }
      if (this.searchValue.custName) {
        url += "&custName=" + this.searchValue.custName;
      }
      if (this.searchValue.chanceName) {
        url += "&chanceName=" + this.searchValue.chanceName;
      }
      if (this.searchValue.rq) {
        url += "&rq=" + this.searchValue.rq;
      }
      if (this.searchValue.userId) {
        url += "&userId=" + this.searchValue.userId;
      }

      this.getRequest(url).then((resp) => {
        this.loading = false;
        if (resp) {
          console.log(resp.data);
          this.queryData = resp.data;
          this.total = resp.count;
        }
      });
    },
  },
};
</script>

<style>
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
	        /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
